
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
import { Chip, FormFields, FilterFields, TableHeaderModel } from '@/models/repsol-template.model';
import { TableAgregadaHeaderModel } from '@/models/repsol-template-aggregate.model';
import moment from 'moment';
import { httpClient } from '@/core';
import ComponentBase from '@/mixins/componentBase';
import RepsolTablePopupComponent from '@/components/repsol-table-popup/RepsolTablePopupComponent.vue';
//import { MdSteppers, MdStep } from 'vue-material/dist/components'


@Component({
  name: 'EjecucionDetallePage',
  components: {
    RepsolFilterBarComponent,
    RepsolFilterChipsComponent,
    RepsolTableComponent,
    RepsolFormPopupComponent,
    RepsolTablePopupComponent
    // MdSteppers, MdStep
  },
})

class EjecucionDetallePage extends ComponentBase {

  @Prop()
  modoEditar: boolean;

  props: true

  isOpenFilters = false;
  isOpenForm = false;
  formIsValid = true;
  formOnlyRead = false;

  deleteFilter = "";
  hoy = moment(new Date()).format("DD/MM/YYYY");
  popupHeaderText = "";

  items: any[] = [];
  operaciones: any[] = [];
  neteo: any[] = [];
  detallado: any[] = [];
  altura: any[] = [];
  triton: any[] = [];

  cierreId: string;
  detalleCierre: any = {};

  active: 'stepOperaciones';
  stepOperaciones = true;
  stepNeteo = true;
  stepTriton = true;
  stepAltura = false;
  stepEnvTriton = false;

  showTritonPopup = false;
  showPopup = false;
  isOpenNeteoDetalleForm = false;
  isOpenTritonDetalleForm = false;
  isOpenAlturaEstadoHistorico = false;

  operacionesTableHeaders: TableHeaderModel[] = [];

  detalladoTableHeaders: TableHeaderModel[] = [];

  neteoTableHeaders: TableHeaderModel[] = [];

  neteoAlturaTableHeaders: TableHeaderModel[] = [];

  alturaTableHeaders: TableHeaderModel[] = [];

  neteoDetalleEjecucionTableHeaders: TableHeaderModel[] = [];

  ordenDetalleEjecucionTableHeaders: TableHeaderModel[] = [];

  alturaHistoricoTableHeaders: TableHeaderModel[] = [];

  tritonTableHeaders: TableHeaderModel[] = [...this.detalladoTableHeaders,
  {
    text: 'ejecuciones.state', value: "estado", sortable: true, as: 'multiselect',
    items: [
      // { id: 'p', nombre: 'Pendiente' },
      // { id: 'g', nombre: 'Guardado' },
      // { id: 'e', nombre: 'Error' }
    ]
  },
  {
    text: 'common.error', value: "error", sortable: true, as: 'text',
  },
  ];

  constructor() {
    super();
  }

  mounted() {
    this.cierreId = this.$route.params.id;
    this.getEjecucionDetalle();
    this.getMaestroProducto();
    this.getMaestroCierreEstado();
    this.getMaestroOperacionTipo();
    this.getMaestroCierreIntegracionEstados();
    this.getMaestroConsolidadoNeteoDetalleEjecucionTipo();
    this.getMaestroOperacionEstado();

    this.operacionesTableHeaders = [
      { text: 'common.identifier', value: "id", sortable: true, as: 'number' },
      { text: 'common.desk', value: "mesaId", sortable: true, as: 'multiselect' },
      {
        text: 'common.product', value: "productoId", sortable: true, as: 'multiselect', items:
          this.maestroProducto
      },
      {
        text: 'common.type', value: "tipoId", sortable: true, as: 'multiselect',
        items: this.maestroOperacionTipo
      },
      {
        text: 'common.line', value: "linea", sortable: true, as: 'select',
        items: this.maestrosLinea
      },
      { text: 'common.strategy', value: "codigoEstrategia", sortable: true, as: 'multiselect' },
      { text: 'ejecuciones.quantity', value: "cantidad", sortable: true, as: 'number' },
    ];

    this.neteoTableHeaders = [

      { text: 'common.identifier', value: "id", sortable: true, as: 'number' },

      {
        text: 'common.type', value: "tipoId", sortable: true, as: 'multiselect',
        items: this.maestroOperacionTipo
      },
      {
        text: 'common.line', value: "linea", sortable: true, as: 'select',
        items: this.maestrosLinea
      },
      { text: 'ejecuciones.quantity', value: "cantidad", sortable: true, as: 'number' },
    ];

    this.neteoAlturaTableHeaders = [

      { text: 'common.identifier', value: "id", sortable: true, as: 'number' },

      {
        text: 'common.type', value: "tipoId", sortable: true, as: 'multiselect',
        items: this.maestroOperacionTipo
      },
      {
        text: 'common.line', value: "linea", sortable: true, as: 'select',
        items: this.maestrosLinea
      },
      { text: 'ejecuciones.quantity', value: "cantidad", sortable: true, as: 'number' },
      {
        text: '', value: "actions", sortable: true, as: '', actions: [
          {
            icon: 'search',
            name: 'historico',
          }

        ]
      },
    ];

    this.neteoDetalleEjecucionTableHeaders = [

      { text: 'common.identifier', value: "id", sortable: true, as: 'number' },
      {
        text: 'common.type', value: "tipoId", sortable: true, as: 'multiselect',
        items: this.maestroConsolidadoNeteoDetalleEjecucionTipo
      },
      { text: 'ejecuciones.quantity', value: "cantidad", sortable: true, as: 'number' },
      { text: 'ejecuciones.ticks', value: "ticks", sortable: true, as: 'number' },
      { text: 'ejecuciones.price', value: "precioTas", sortable: true, as: 'number' },
    ];

    this.ordenDetalleEjecucionTableHeaders = [

      { text: 'ejecuciones.detailed_order_consolidated', value: "consolidadoOrdenDetalladaId", sortable: true, as: 'number' },
      {
        text: 'ejecuciones.state', value: "status", sortable: true, as: 'multiselect',
        items: this.maestroCierreIntegracionEstados
      },
      { text: 'ejecuciones.result', value: "result", sortable: true, as: 'multiselect' },
      { text: 'ejecuciones.executing_commission', value: "executingCommission", sortable: true, as: 'multiselect' },
      { text: 'ejecuciones.clearing_commission', value: "clearingCommission", sortable: true, as: 'multiselect' },
    ];

    this.detalladoTableHeaders = [

      { text: 'common.identifier', value: "id", sortable: true, as: 'number' },
      { text: 'ejecuciones.trader', value: "trader", sortable: true, as: 'text' },
      { text: 'ejecuciones.close_date', value: "fechaCierre", sortable: true, as: 'date' },
      { text: 'common.strategy', value: "estrategia", sortable: true, as: 'text' },
      { text: 'ejecuciones.broker_executing', value: "brokerExecuting", sortable: true, as: 'text' },
      { text: 'ejecuciones.broker_clearing', value: "brokerClearing", sortable: true, as: 'text' },
      { text: 'ejecuciones.position', value: "posicion", sortable: true, as: 'text' },
      { text: 'ejecuciones.quantity', value: "lotes", sortable: true, as: 'text' },
      { text: 'ejecuciones.commodity', value: "commodity", sortable: true, as: 'text' },
      { text: 'common.market', value: "mercado", sortable: true, as: 'text' },
      { text: 'ejecuciones.month', value: "mes", sortable: true, as: 'text' },
      { text: 'ejecuciones.year', value: "anyo", sortable: true, as: 'text' },
      { text: 'ejecuciones.state', value: "estado", sortable: true, as: 'text' },
      {
        text: '', value: "actions", sortable: true, as: '', actions: [
          {
            icon: 'search',
            name: 'ordenDetallada',
          }

        ]
      }
    ];

    this.alturaHistoricoTableHeaders = [
      { text: 'ejecuciones.state', value: "cierreIntegracionEstadoId", sortable: true, as: 'text', items: this.maestroCierreIntegracionEstados },
      { text: 'common.date', value: "fecha", sortable: true, as: 'date' },
    ];
  }

get isEnviarTritonDisabled(): boolean {
  const value = this.detalleCierre.enviarATriton;
  return value === false || value === 'false' || value === 0 || value === '0' || value === null || value === undefined;
}


get isEnviarAlturaDisabled(): boolean {
  const value = this.detalleCierre.enviarAltura;
  if (value === true || value === 1) {
    return false;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1' || normalized === 'si' || normalized === 'sí') {
      return false;
    }
  }
  return true;
}
  getEjecucionDetalle() {

    this.openSpinner("ejecuciones.cargar");
    this.get({ apiUrl: `/api/ejecucion/${this.cierreId}` })
      .then((response) => {
        const data = response || {};

        const normalizeArray = (value: any): any[] => {
          if (Array.isArray(value)) return value;
          if (value && Array.isArray(value.$values)) return value.$values;
          return [];
        };

        this.detalleCierre = {
          ...data,
          // Normalize possible PascalCase or $values payloads
          operaciones: normalizeArray(data.operaciones ?? data.Operaciones),
          neteo: normalizeArray(data.neteo ?? data.Neteo),
          triton: normalizeArray(data.triton ?? data.Triton),
          alturaHistorico: normalizeArray(data.alturaHistorico ?? data.AlturaHistorico),
        };

        this.operaciones = this.detalleCierre.operaciones;
        this.neteo = this.detalleCierre.neteo;
        this.triton = this.detalleCierre.triton;
        this.altura = this.detalleCierre.alturaHistorico;

        this.detalleCierre.fechaFormateada = moment(this.detalleCierre.fecha).format('DD/MM/YYYY');
        this.stepAltura = this.detalleCierre.estadoAlturaId != 'PEND';
        this.stepEnvTriton = this.detalleCierre.estadoTritonId != 'PEND';
        this.closeSpinner();
      })
      .catch(() => {
        this.mostrarKO("operaciones.errorCargar");
        this.closeSpinner();
      });
  }

  enviarAltura() {
    this.detalleCierre.estadoAlturaId = "ENV";
    this.actualizarEstados('envioAltura');
  }

  enviarTriton() {
    this.detalleCierre.estadoTritonId = "OK";
    this.actualizarEstados('envioTriton');
  }

  abrirHistoricoAltura() {
    this.popupHeaderText = "ejecuciones.alturaHistorico";
    this.isOpenAlturaEstadoHistorico = true;
  }

  actualizarEstados(tipo: string) {
    this.openSpinner("ejecuciones.cargar");
    this.put({ apiUrl: `/api/ejecucion/${tipo}/${this.cierreId}`, entity: this.detalleCierre })
      .then(() => {
        this.closeSpinner();
        this.getEjecucionDetalle();
      })
      .catch(() => {
        // Manejar errores si es necesario
        this.closeSpinner();
      });
  }


  volver() {
    this.$router.push({ path: this.modoEditar ? '/cierres/ejecuciones' : '/cierres/historicos' });
  }

  formEventAction(action: string, item: any): void {
    switch (action) {


      case 'cerrar':
        this.isOpenNeteoDetalleForm = false;
        this.isOpenTritonDetalleForm = false;
        this.isOpenAlturaEstadoHistorico = false;
        break;

      default:
        break;
    }
  }

  tableEventAction(action: string, item: any): void {
    console.log("table action", action, item);
    this.items = [];
    switch (action) {

      case 'historico':

        this.popupHeaderText = "ejecuciones.historico";

        this.items = item.cierreNeteoEstados;
        this.openSpinner("ejecuciones.cargar");

        this.isOpenNeteoDetalleForm = true;

        this.closeSpinner();

        break;
      case 'ordenDetallada':

        this.popupHeaderText = "ejecuciones.ordenDetallada";

        this.items = item.cierreTritonEstados;
        this.openSpinner("ejecuciones.cargar");

        this.isOpenTritonDetalleForm = true;

        this.closeSpinner();

        break;

      default:
        break;
    }
  }

  getAlturaHistoricoDetalle() {
    if (this.altura && this.altura.length > 0) {
      return this.altura;
    }
    return [];
  }

  getFileNameFromContentDisposition(contentDisposition?: string): string | null {
    if (!contentDisposition) {
      return null;
    }

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
      return decodeURIComponent(utf8Match[1].replace(/["']/g, ''));
    }

    const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    return fileNameMatch && fileNameMatch[1] ? fileNameMatch[1] : null;
  }

  isXlsxBinary(data: ArrayBuffer): boolean {
    const bytes = new Uint8Array(data);
    return bytes.length >= 4
      && bytes[0] === 0x50
      && bytes[1] === 0x4b
      && bytes[2] === 0x03
      && bytes[3] === 0x04;
  }

  triggerBlobDownload(data: ArrayBuffer, fileName: string, mimeType: string): void {
    const blob = new Blob([data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  getTritonFallbackBaseName(): string {
    const locale = String(this.$i18n?.locale || '').toLowerCase();
    return locale.startsWith('en') ? 'Download_Csv_Triton' : 'Descarga_Csv_Triton';
  }

  getFileExtension(fileName: string): 'csv' | 'xlsx' | null {
    const lower = fileName.toLowerCase();
    if (lower.endsWith('.xlsx')) return 'xlsx';
    if (lower.endsWith('.csv')) return 'csv';
    return null;
  }

  isLegacyTritonName(fileName: string): boolean {
    const base = fileName
      .replace(/\.[^./\\]+$/u, '')
      .trim()
      .toLowerCase();

    return /^triton(_\d+)?$/i.test(base)
      || /^csv_triton(_\d+)?$/i.test(base)
      || /^triton_csv(_\d+)?$/i.test(base);
  }

  resolveDownloadFileName(serverFileName: string | null, detectedExtension: 'csv' | 'xlsx'): string {
    if (!serverFileName) {
      return `${this.getTritonFallbackBaseName()}.${detectedExtension}`;
    }

    if (!this.isLegacyTritonName(serverFileName)) {
      return serverFileName;
    }

    const serverExtension = this.getFileExtension(serverFileName);
    const extension = serverExtension || detectedExtension;
    return `${this.getTritonFallbackBaseName()}.${extension}`;
  }

  async downloadTriton(): Promise<void> {
    const route = `/api/ejecucion/Download?cierreId=${this.cierreId}&localized=true`;

    try {
      const response = await httpClient().instance.post(route, {}, { responseType: 'arraybuffer' });
      const contentType = String(response.headers?.['content-type'] || response.headers?.['Content-Type'] || '').toLowerCase();
      const contentDisposition = response.headers?.['content-disposition'] || response.headers?.['Content-Disposition'];
      const serverFileName = this.getFileNameFromContentDisposition(contentDisposition);
      const looksLikeXlsx = this.isXlsxBinary(response.data)
        || contentType.includes('spreadsheetml')
        || contentType.includes('application/vnd.ms-excel')
        || (serverFileName ? /\.xlsx$/i.test(serverFileName) : false);

      const extension: 'csv' | 'xlsx' = looksLikeXlsx ? 'xlsx' : 'csv';
      const mimeType = looksLikeXlsx
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'text/csv;charset=utf-8';

      const fileName = this.resolveDownloadFileName(serverFileName, extension);

      this.triggerBlobDownload(response.data, fileName, mimeType);
    } catch (error) {
      this.mostrarKO('ejecuciones.koListado');
    }
  }

  async descargar(): Promise<void> {
    await this.downloadTriton();
  }
}

export default EjecucionDetallePage;
